import { useTheme } from "@material-ui/core";
import React from "react";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles, Theme } from "@material-ui/core/styles";
import Markdown from "../Markdown"

const LightTooltip = withStyles((theme: Theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[3],
    fontSize: 16,
    padding: "20px",
  },
  arrow: {
    fontSize: 20,
    color: theme.palette.common.white,
  },
}))(Tooltip);

const Label = (props: { label: string; tooltip?: string }) => {
  const theme = useTheme();

  let tooltip = null;
  if (props.tooltip) {
    tooltip = (
      <LightTooltip
        title={<Markdown options={{ forceInline: true }}>{props.tooltip}</Markdown>}
        aria-label={props.tooltip}
        placement="right"
        arrow
        enterTouchDelay={0}
        leaveTouchDelay={3000}
      >
        <InfoOutlinedIcon htmlColor={theme.palette.primary.light} fontSize="small" />
      </LightTooltip>
    );
  }
  return (
    <div
      style={{
        textAlign: "left",
        fontWeight: 800,
        display: "flex",
        alignItems: "center",
        // fontSize:15
      }}
    >
      <div style={{ marginRight: theme.spacing(1) }}>{props.label}</div>
      {tooltip}
    </div>
  );
};

export default Label;
